import React from 'react';

import * as Icon from 'ubs-icons';

const UVersionPopup = (props) => {
    return (
        <React.Fragment>
            <div className="u_version-popup">
                <div className="u_version-popup-overlay"/>
                <div className="u_version-popup-inner">
                    <div className="u_version-popup-header">
                        <h3>{props.moduleIcon} {props.moduleName}: Version Update</h3>
                        {props.close && <span onClick={props.close}><Icon.Close size={16} fill="#007AFF" className="u_cp"/></span>}
                    </div>
                    <div className="u_version-popup-body">
                        <Icon.NewVersion size={36}/>
                        <div className="u_popup-content">
                            <h4>A new version of {props.moduleName} is available</h4>
                            <p>Refresh to get the latest version.</p>
                        </div>
                    </div>
                    <div className="u_version-popup-footer">
                        {
                            props.refresh &&
                            <div>
                                <button className="u_button u_button-blue"
                                        onClick={() => props.refresh()}>Refresh
                                </button>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default UVersionPopup;